import { Grid, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import { Spinner } from "../../components/Loading/Spinner";
import SuscrPickOrg from "../../components/Profile/SuscrPickOrg";
import OASPanel from "../../components/Table/OAS/OASPanel";
import { useOAS } from "../../context/SuperAdmin/OASContexts/OASContext";
import { useAuthContext } from "../../hooks/Auth";

const OASPage = () => {
  const { organizaciones, selectedOrg, handleSelectChange, isLoadingOrgs } =
    useOAS();

  const { canAccess } = useAuthContext();
  const isSuperAdmin = canAccess("view:oas");

  return (
    <Grid
      container
      spacing={4}
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        pt: 3,
        fontFamily: "Montserrat",
        flexGrow: 1, // <--- en lugar de height: "100%"
        minHeight: 0, // <--- evita desbordes
      }}
    >
      {/* Título */}
      <Grid item>
        <Typography variant={"h4"} sx={{ color: "#005559", fontSize: "30px" }}>
          <b>OAS</b> | Gestor de OAS
        </Typography>
      </Grid>

      {isLoadingOrgs ? (
        <Grid item>
          <Spinner msg="Cargando por favor espere..." />
        </Grid>
      ) : (
        <>
          {/* Seleccionar organizacion */}
          {isSuperAdmin && (
            <Grid item>
              <SuscrPickOrg
                organizaciones={organizaciones}
                selectedOrg={selectedOrg ? selectedOrg : ""}
                handleChange={handleSelectChange}
                isLoading={isLoadingOrgs}
              />
            </Grid>
          )}

          {/* Menú de OAS */}
          {selectedOrg && (
            <Grid item sx={{ flexGrow: 1, minHeight: 0 }}>
              <OASPanel />
            </Grid>
          )}
        </>
      )}
    </Grid>
  );
};

export default OASPage;
